//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//import Components
import {storageRef} from '../../../../firebase';

import {FormGroup, Col, Label} from 'reactstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'

//import Styles
import './QuillEditor.css';

//지연삭제하자
class QuillEditor extends Component {
    constructor(props) {
        super(props);
    }

    imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();
        input.onchange = (e) => {
            const file = input.files[0];
            if(/^image\//.test(file.type)) {
                this.saveToServer(file);
            }
        }
    }

    saveToServer = (file) => {
        const imageRef = storageRef.child(`${this.props.imageStoragePath}/${this.props.id}_${this.props.imageCount}.jpg`);
        const task = imageRef.put(file);
        task.on('state_changed',
            (snapshot) => {
            },
            (e) => {
            }, 
            () => {
                imageRef.getDownloadURL()
                    .then((url) => {
                        this.insertToEditor(url);
                    })
                    .catch((e) => {

                    })
            })
    }

    insertToEditor = (downloadURL) => {
        const range = this.quillRef.getEditor().getSelection();
        this.quillRef.getEditor().insertEmbed(range.index, 'image', downloadURL);
        this.props.setImageCount(this.props.imageCount + 1);
    }

    componentDidMount() {
        this.quillRef.getEditor().on('text-change', (delta, oldContents, source) => {
            if (source === 'user') {
                let currentContents = this.quillRef.getEditor().getContents();
                const deleteDiff = currentContents.diff(oldContents);
                deleteDiff.ops.map(op => {
                    if (op.insert &&
                        op.insert.image) {
                        const jpgIndex = op.insert.image.indexOf('.jpg');
                        const index = parseInt(op.insert.image[jpgIndex - 1]);
                        if (index !== NaN) {
                            this.props.addShouldDeletes(index)
                        }
                    }
                })
                const insertDiff = oldContents.diff(currentContents);
                insertDiff.ops.map(op => {
                    if(op.insert &&
                        op.insert.image) {
                            const jpgIndex = op.insert.image.indexOf('.jpg');
                            const index = parseInt(op.insert.image[jpgIndex - 1]);
                            if(index !== NaN) {
                                this.props.removeShouldDeletes(index);
                            }
                        }
                })
            }
        })
    }

    render() {
        const modules = {
            toolbar: {
                container: [
                    [{ 'header': [1, 2, false] }],
                    ['bold', 'italic', 'underline', 'blockquote'],
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    ['formula','link', 'image'],
                    ['clean']
                ],
                handlers : {
                    'image' : this.imageHandler
                }
            }
        }
        const formats = [
            'header',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'image'
        ]

        return (
            <FormGroup 
                row
                disabled={this.props.disabled}
            >
                <Label sm={1} size="sm"><b>{this.props.label}</b></Label>
                <Col sm={10}>
                    <ReactQuill 
                        ref={el => this.quillRef = el}
                        modules={modules}
                        formats={formats}
                        value={this.props.value}
                        onChange={this.props.onChange}
                    />
                </Col>
            </FormGroup>
        );
    }
}
export default QuillEditor;

QuillEditor.defaultProps = {
    disabled : false
}
QuillEditor.propTypes = {
    textStoragePath : PropTypes.string.isRequired,
    imageStoragePath : PropTypes.string.isRequired,
    id : PropTypes.string.isRequired,
    value : PropTypes.string.isRequired,
    onChange : PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Components/QuillEditor/QuillEditor.js